<template>
  <fragment v-if="item.childNodes">
    <template v-if="!item.childNodes.length">
      <el-submenu  :index="item.pageUrl" popper-class="common-submenu-box">
        <template slot="title">
          <div @click="switchRouter(item.pageUrl)"
            :class="`${isActiveRoute(item.pageUrl) ? 'common-submenu-box-title common-submenu-box-title-active' : 'common-submenu-box-title'}`">
            <!-- <img :src="item.iconPath" class="icon" /> -->
            <div class="main-file-box" :style="{ background: `${item?.iconInfo?.color}` }">
              <!-- <icon-svg icon-class="ic-zhushitu" size="22px" class="icon" /> -->
              <icon-svg :icon-class="item?.iconInfo?.className" :size="item?.iconInfo?.size" class="icon" />
            </div>
            <transition name="el-zoom-in-center">
              <div class="name" v-show="collapse">{{ item.menuName }}</div>
            </transition>
          </div>
        </template>
      </el-submenu>
    </template>
    <el-submenu v-else :index="item.pageUrl" :class="`${item.isCheck ? '' : 'hidden'}`"
      popper-class="common-submenu-box common-submenu-box-translate">
      <template slot="title">
        <div
          :class="`${isSecActiveRoute(item) ? 'common-submenu-box-title common-submenu-box-title-active' : 'common-submenu-box-title'}`">
          <div class="main-file-box" :style="{ background: `${item?.iconInfo?.color}` }">
            <icon-svg :icon-class="item?.iconInfo?.className" :size="item?.iconInfo?.size" class="icon" />
            <!-- <img :src="item.iconPath" class="icon" /> -->
          </div>
          <transition name="el-zoom-in-center">
            <div v-show="collapse" class="name">{{ item.menuName }}</div>
          </transition>
        </div>
      </template>

      <template v-for="(sub, index) in item.childNodes">
        <tree-menu v-if="sub.childNodes && sub.childNodes.length" :class="`${sub.isCheck ? '' : 'hidden'}`" :item="sub"
          :key="index" />
        <el-menu-item v-else :class="`${sub.isCheck ? '' : 'hidden'}`" :key="index + 1" :index="sub.pageUrl">
          {{ sub.menuName }}
        </el-menu-item>
      </template>
    </el-submenu>
  </fragment>
</template>

<script>
export default {
  name: "TreeMenu",
  props: {
    item: {
      type: Object,
      required: true,
    },
    collapse: {
      type: Boolean,
      required: true,
    },
  },
  methods: {
    switchRouter(pageUrl) {
      this.$router.push(pageUrl);
    },
  },

  computed: {
    isActiveRoute() {
      return (pageUrl) => {
        return this.$route.path === '/' + pageUrl;
      }
    },
    isSecActiveRoute() {
      return (pageUrl) => {
        const childNodes = pageUrl.childNodes.map((item) => item.pageUrl)
        return childNodes.includes(this.$route.path.split('/')[1])
      }
    }
  },
};
</script>

<style lang="less" scoped>
.icon {
  width: 25px;
  height: 25px;
  object-fit: contain;
}

.name {
  font-size: 14px;
  color: var(--aside-bg-color);
}

.main-file-box {
  color: var(--aside-bg-color);
  visibility: visible !important;
  width: 24px;
  height: 24px;
  margin-top: 16px;
  margin-bottom: 8px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;

  & span {
    display: inline !important;
    visibility: visible !important;
  }
}
</style>

<style lang="less">
.common-submenu-box-translate{
  transform: translateY(12px);
}
</style>